const reducer = (state, action) => ({
  ...state,
  ...action.result,
  loading: false,
  initialLoadComplete: true,
  error: null,
});

export default reducer;
